import {triggersApi} from 'sources/api';
import cancelIfSending from 'sources/cancelIfSending';

const FilterWordSource = cancelIfSending({
  fetchAll() {
    return triggersApi.getJson('/account/topics').then(response => response);
  },
});

export default FilterWordSource;
